module.exports = __webpack_public_path__ + "img/48000.f1096dfb.jpg";